import { useEffect, useState } from "react";
import { toast } from "sonner";
import { admin, fileUrl } from "../../lib/api";
import { panel, btnPrimary, PageHead } from "../ui";
import { Upload, Trash2, Copy } from "lucide-react";

export default function MediaLibrary() {
  const [list, setList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const load = () => admin.get("/admin/media").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    setUploading(true);
    for (const file of files) {
      const fd = new FormData(); fd.append("file", file);
      try { await admin.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } }); }
      catch { toast.error(`Failed: ${file.name}`); }
    }
    setUploading(false); toast.success("Uploaded"); load();
  };
  const del = async (m) => { await admin.delete(`/admin/media/${m.id}`); load(); };
  const copy = (m) => { navigator.clipboard.writeText(fileUrl(m.url)); toast.success("URL copied"); };

  return (
    <div>
      <PageHead title="Media Library">
        <label className={btnPrimary + " cursor-pointer flex items-center gap-1.5"} data-testid="media-upload-btn">
          <Upload size={14} /> {uploading ? "Uploading…" : "Upload"}
          <input type="file" multiple accept="image/*,video/*" className="hidden" onChange={upload} />
        </label>
      </PageHead>
      {list.length === 0 ? <p className="text-zinc-500">No media yet. Upload images to use across products and homepage.</p> : (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
          {list.map((m) => (
            <div key={m.id} className={`${panel} group relative`}>
              <div className="aspect-square bg-zinc-900 overflow-hidden">
                {m.content_type?.startsWith("video") ? <video src={fileUrl(m.url)} className="w-full h-full object-cover" /> : <img src={fileUrl(m.url)} alt={m.alt} className="w-full h-full object-cover" />}
              </div>
              <div className="absolute inset-0 bg-black/70 opacity-0 group-hover:opacity-100 flex items-center justify-center gap-3 transition-opacity">
                <button onClick={() => copy(m)} className="text-white"><Copy size={16} /></button>
                <button onClick={() => del(m)} className="text-red-400"><Trash2 size={16} /></button>
              </div>
              <p className="text-[10px] text-zinc-600 p-1 truncate">{m.original_filename}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
